import { findKey, inRange, mapValues } from "es-toolkit/compat";

import {
  PERCENTAGE_EXCLUSIVE_END,
  PERCENTAGE_MAX,
} from "@/constants/percentage.constants";
import { ColorScale, ScaleRange } from "./range.helpers.decl";

export function getColorFromRange<T extends string>(colorScale: ColorScale<T>) {
  return (value: number | null) => {
    const formattedColorScale = mapValues(
      colorScale,
      (range) =>
        // Bumps 100 because, inRange is exclusive.
        (range ?? []).map((value) =>
          value === PERCENTAGE_MAX ? PERCENTAGE_EXCLUSIVE_END : value
        ) as ScaleRange
    );

    return findKey(formattedColorScale, (range) =>
      inRange(value ?? 0, range?.at(0) ?? -1, range?.at(1))
    ) as T | undefined;
  };
}
